import {filter} from "lodash";

export const createLocationSlug = (...locations: (string | undefined)[]): string => {
    return filter(locations).join("/");
};
